<div tid="navigation-menu-container" class="navigation-menu-container">
    <div class="menu-container">
        <div *ngFor="let menu of navigationMenuContainer;let i = index; trackBy:trackByFn" class="li-container">
            <div class="div-container" (click)="itemOnClick($event,menu,i)" kendoTooltip position="left"
                tooltipClass="tooltip-adjust-right">
                <div class="icon-container" [attr.tid]="menu.tid" [title]="menu.caption"
                    [ngClass]="{'div-border-selected':selectedIndex===i}">
                    <smart-icon class="menu-image"
                        [name]="selectedIndex===i ? menu.icon.name + '-selected' : menu.icon.name">
                    </smart-icon>
                </div>
            </div>
        </div>
        <div class="icon-container setting-icon" tid="settings">
            <!--hide setting template icon-->
            <smart-icon *ngIf="isShowConfig" class="menu-image hoverColor" name="form-builder"
                (click)="clickSetting($event)">
            </smart-icon>
        </div>
    </div>
</div>